import { getOrdersInvoicesDt } from "~/helpers/backendHelper";
import { getOrdersInvoicesDtErr, getOrdersInvoicesDtOk } from "./actions";
import { GET_ORDERS_INVOICES_DT } from "./actionTypes";
import { takeEvery, put, call } from "redux-saga/effects";

/********** DATATABLE **********/

function* onGetOrdersInvoicesDt({ payload: { params } }) {
  try {
    const response = yield call(getOrdersInvoicesDt, params);
    yield put(getOrdersInvoicesDtOk(response));
  } catch (error) {
    yield put(getOrdersInvoicesDtErr(error));
  }
}

function* ordersInvoicesSaga() {
  yield takeEvery(GET_ORDERS_INVOICES_DT, onGetOrdersInvoicesDt);
}

export default ordersInvoicesSaga;